module.exports = __webpack_public_path__ + "images/speed-ten-active.c133c9adfe5988c194c61f0b6e2efd25.png";